import { mutator } from 'satcheljs';
import { activityFeedItemAction } from '../actions/activityFeedItemAction';
import { getActivityFeedStore } from '../store/store';

mutator(activityFeedItemAction, ({ itemId }) => {
    const feedItems = getActivityFeedStore().items;
    if (feedItems.has(itemId)) {
        let targetItem = feedItems.get(itemId);
        targetItem.isRead = true;
    }
});
